// @flow
import React from 'react';
import * as Yup from 'yup';
import styled from 'styled-components';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Auth } from 'utils/ExportCommon';
import { get } from 'lodash';

const Wrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;

const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: ${({ padding = '10px 30px' }) => padding};
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
  margin: 0 !important;
  &:placeholder: {
    color: #9b9b9b;
  }
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: #ff4c4c;
`;

const FormGroup = styled.div`
  position: relative;
`;

export const StyledSubmitButton = styled.button`
  display: ${({ hidden }) => (hidden ? 'none' : 'inline-block')};
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  height: 35px;
  width: 87px;
  line-height: normal;
  color: white;
  background-color: #${({ bColor }) => (bColor ? bColor : '4F5EA3')};
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  padding: 8px 0;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
`;

const IconWhatsapp = styled.img.attrs({
  src: Auth.wsapp
})`
  margin: 0 8px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;

type FormCodeWhats = {
  codeWspp: string
};

type PropsType = {
  sendWhatsappVerification: (code: string) => void,
  placeholder: string,
  marginBottom?: any,
  padding?: string,
  textButton?: string,
  showButton?: boolean,
  showIconWhatsapp?: boolean
};

export default class VerifyWhatsappCodeComponent extends React.Component<PropsType> {
  static defaultProps = {
    textButton: 'Enviar',
    showIconWhatsapp: true
  };

  constructor(props: PropsType) {
    super(props);
    this.validationSchema = this.validationSchema.bind(this);
    this.submitData = this.submitData.bind(this);
  }

  validationSchema = () => {
    return Yup.object().shape({
      codeWspp: Yup.string()
        .required('Campo requerido')
        .min(4, 'El código es demasido corto, 4 caracteres mínimo.')
    });
  };

  submitData = (values: FormCodeWhats, { resetForm }: any): void => {
    this.props.sendWhatsappVerification(values.codeWspp);
    resetForm({ codeWspp: '' });
  };

  renderButtonSubmit = (values: any) => {
    let showButton = get(this.props, 'showButton', false);
    if (values.codeWspp == '' && !showButton) {
      return null;
    }

    return (
      <StyledSubmitButton type="submit" bColor={'278C7E'} hidden={false}>
        {this.props.textButton}
      </StyledSubmitButton>
    );
  };

  renderIconWhatsapp = () => {
    let showIconWhatsapp = get(this.props, 'showIconWhatsapp');

    if (!showIconWhatsapp) {
      return null;
    }
    return <IconWhatsapp />;
  };

  render() {
    const { placeholder } = this.props;
    return (
      <Formik
        initialValues={{ codeWspp: '' }}
        validationSchema={this.validationSchema()}
        onSubmit={this.submitData}
      >
        {({ values, errors, touched }) => (
          <Form style={{ width: '100%' }}>
            <FormGroup marginBottom={this.props.marginBottom}>
              <Wrapper>
                {this.renderIconWhatsapp()}
                <StyledInput
                  padding={this.props.padding}
                  type="text"
                  name="codeWspp"
                  placeholder={placeholder}
                  className={
                    errors.codeWspp && touched.codeWspp ? 'has-error' : ''
                  }
                />
                {this.renderButtonSubmit(values)}
              </Wrapper>
            </FormGroup>
            <StyledErrorMessage name="codeWspp" component="div" />
          </Form>
        )}
      </Formik>
    );
  }
}
